import { __decorate } from "tslib";
import { VuexModule, Module, Mutation, getModule } from 'vuex-module-decorators';
import store from '@blade/common/store';
let ZoneType = class ZoneType extends VuexModule {
    zoneTypeData = [];
    updataZoneType(data) {
        this.zoneTypeData = data;
    }
    clearZoneType() {
        this.zoneTypeData = [];
    }
};
__decorate([
    Mutation
], ZoneType.prototype, "updataZoneType", null);
__decorate([
    Mutation
], ZoneType.prototype, "clearZoneType", null);
ZoneType = __decorate([
    Module({ dynamic: true, store, name: 'senseXplorer/ZoneType' })
], ZoneType);
export const ZoneTypeModule = getModule(ZoneType);
